import { createAsyncThunk } from "@reduxjs/toolkit";

import { type Trainee, type TraineeProfile } from "@fitness-app/data-models/entities/Trainee";

import { type AsyncThunkCreator } from "../../../index";
import { TRAINEE_REDUCER_NAME } from "../types";

type Payload = {
  id: string;
  profile: Partial<Trainee>;
  additionalData?: Partial<TraineeProfile>;
};

export const updateTrainee = createAsyncThunk<Trainee | null, Payload, AsyncThunkCreator<string>>(
  `${TRAINEE_REDUCER_NAME}/updateTrainee`,
  async (payload, { rejectWithValue, extra: { db, analytics } }) => {
    const { data, error } = await db
      .from("trainee")
      .update({ ...payload.profile, updatedAt: new Date().toISOString() })
      .eq("id", payload.id)
      .select("*")
      .returns<Trainee[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    // An RLS-filtered row comes back as an empty set, not an error. Treated as
    // fulfilled it left the caller with a toggle that silently snapped back —
    // which is how the administration write block hid for so long.
    if (!data[0]) {
      return rejectWithValue("Nie udało się zaktualizować klientki — brak uprawnień do edycji tego profilu.");
    }

    analytics.track("update_trainee");

    return { ...(payload.additionalData || {}), ...data[0] };
  },
);
